import React, {useState, useEffect} from 'react';

import {calculateOnTrack} from 'shared/utils';
import {OnTrack as OnTrackType, Student} from 'src/types/store';
import UserService from 'src/services/UserService';

import Header from './header';
import Display from './display';

interface OnTrackProps {
  notOnTrack: () => void;
  onTrack: OnTrackType;
}

interface OnTrackInfo {
  onTrackPercentage: number;
  text: string[];
  totalCredits: number;
  finished: boolean;
  goalCredits: number;
}

export type PartialStudent = Pick<Student, 'highSchoolInfo'> & {
  firstName: string;
  lastName: string;
  totalCredits: number;
};

const OnTrack = ({notOnTrack, onTrack}: OnTrackProps) => {
  const [student, setStudent] = useState<PartialStudent | null>(null);
  const [onTrackInfo, setOnTrackInfo] = useState<OnTrackInfo>({
    onTrackPercentage: 0,
    text: [],
    totalCredits: 0,
    finished: false,
    goalCredits: 0,
  });

  useEffect(() => {
    UserService.getData<PartialStudent>([
      'highSchoolInfo',
      'firstName',
      'lastName',
      'totalCredits',
    ]).then(setStudent);

    window.Raise.vent.on<number>('totalCreditsUpdated', (updatedCredits: number) => {
      setStudent((previousValue) => {
        if (previousValue) {
          return {...previousValue, totalCredits: updatedCredits};
        } else {
          return null;
        }
      });
    });

    return () => window.Raise.vent.off('totalCreditsUpdated');
  }, []);

  useEffect(() => {
    if (!student) {
      return;
    }

    const info = calculateOnTrack(student.totalCredits, student.highSchoolInfo?.graduationYear);
    setOnTrackInfo(info);

    if (info.finished) {
      return;
    } else {
      setTimeout(notOnTrack, 100);
    }
  }, [student, notOnTrack]);

  if (!student || (onTrackInfo.finished && onTrack.onTrack)) {
    return null;
  }

  return (
    <div className="on-track">
      <div className={`on-track-wrapper ${onTrackInfo.finished ? 'finished' : ''}`}>
        {!onTrackInfo.finished && <Header key="header" />}
        <Display student={student} onTrack={onTrack} />
      </div>
    </div>
  );
};

export default OnTrack;
